import { render } from "./ProductWarehouse.vue?vue&type=template&id=2ec42574"
import script from "./ProductWarehouse.vue?vue&type=script&lang=js"
export * from "./ProductWarehouse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__